export default __webpack_public_path__ + "static/media/coloured-card-with-btn.c6bf6300.jpg";